(function(){
  if (window.__dfxCoreInit) return;
  window.__dfxCoreInit = true;

  /* Nothing in here reads layout during a scroll. Reading something like
     scrollHeight mid-scroll forces the browser to recalculate layout on
     every frame, which is what makes scrolling stutter on long pages. The
     page height is measured once and refreshed only on resize or load. */
  var docH = 0;
  var winH = 0;
  function measure(){
    winH = window.innerHeight;
    docH = document.documentElement.scrollHeight - winH;
    if (docH < 1) docH = 1;
  }

  var bar = null, top = null;
  var ticking = false;

  function frame(){
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (bar) {
      var p = y / docH;
      if (p < 0) p = 0;
      if (p > 1) p = 1;
      bar.style.transform = 'scaleX(' + p + ')';
    }
    if (top) {
      var on = y > 600;
      if (on !== top._on) { top._on = on; top.classList.toggle('is-on', on); }
    }
  }
  function onScroll(){
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(frame);
  }

  window.addEventListener('scroll', onScroll, {passive: true});
  window.addEventListener('resize', function(){ measure(); onScroll(); }, {passive: true});
  window.addEventListener('load', measure, {passive: true});

  document.addEventListener('DOMContentLoaded', function(){
    bar = document.getElementById('dfx-progress');
    top = document.getElementById('dfx-top');
    measure();

    /* reveal on enter, via IntersectionObserver so nothing runs on scroll */
    var reveals = document.querySelectorAll('.dfx-reveal');
    if (reveals.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries){
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              entries[i].target.classList.add('is-in');
              io.unobserve(entries[i].target);
            }
          }
        }, {rootMargin: '0px 0px -8% 0px', threshold: 0.05});
        for (var r = 0; r < reveals.length; r++) io.observe(reveals[r]);
      } else {
        for (var r2 = 0; r2 < reveals.length; r2++) reveals[r2].classList.add('is-in');
      }
    }

    if (top) {
      top.addEventListener('click', function(){
        window.scrollTo({top: 0, behavior: 'smooth'});
      });
    }

    /* product gallery thumbnails */
    var main = document.getElementById('dfx-pdp-main');
    if (main) {
      var thumbs = document.querySelectorAll('[data-dfx-thumb]');
      for (var t = 0; t < thumbs.length; t++) {
        (function(b){
          b.addEventListener('click', function(){
            var src = b.getAttribute('data-src');
            if (!src) return;
            main.src = src;
            for (var o = 0; o < thumbs.length; o++) {
              thumbs[o].setAttribute('aria-current', thumbs[o] === b ? 'true' : 'false');
            }
          });
        })(thumbs[t]);
      }
    }

    /* quantity steppers */
    document.addEventListener('click', function(ev){
      var b = ev.target.closest('[data-dfx-qty]');
      if (!b) return;
      var input = document.getElementById(b.getAttribute('data-dfx-qty'));
      if (!input) return;
      var n = parseInt(input.value, 10);
      if (isNaN(n)) n = 1;
      var min = parseInt(input.getAttribute('min'), 10);
      if (isNaN(min)) min = 0;
      n = b.getAttribute('data-dir') === 'up' ? n + 1 : n - 1;
      if (n < min) n = min;
      input.value = n;
      input.dispatchEvent(new Event('change', {bubbles: true}));
    });

    frame();
  });
})();
